module.exports = __webpack_public_path__ + "img/zone350400.5c93328e.png";